import { NpImageSection } from "src/components/np-design/sections/image/NpImageSection"
import { HeroSectionData } from "src/data/product-details/types"

export type HeroSectionProps = HeroSectionData

export const HeroSection = ({
  heading,
  description,
  image,
  backgroundColor: background = "#fff",
  desktopTextSide = "right",
}: HeroSectionProps) => {
  return (
    <NpImageSection
      image={image}
      heading={heading}
      description={description}
      background={background}
      imageSide={desktopTextSide === "left" ? "right" : "left"}
    />
  )
}
